import React, { useEffect, useState, useContext } from "react";
import { Box, Typography } from "@mui/material";
import { Container, Row, Col } from 'react-bootstrap';
import SimpleCard from "../../components/SimpleCard/SimpleCard";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Topbar from "../../components/topbar/Topbar";
import { StateContext } from "../../Context/StateContext";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import { ToastContainer, toast } from "react-toastify";
import axios from "axios";

const normalizeGiftImageUrls = (giftPhoto, giftGIF) => {
  if (Array.isArray(giftPhoto)) {
    const photos = giftPhoto.filter(
      (photo) => typeof photo === "string" && photo.trim() && photo !== "--"
    );
    if (photos.length > 0) {
      return photos;
    }
  } else if (
    typeof giftPhoto === "string" &&
    giftPhoto.trim() &&
    giftPhoto !== "--"
  ) {
    return [giftPhoto];
  }

  if (typeof giftGIF === "string" && giftGIF.trim() && giftGIF !== "--") {
    return [giftGIF];
  }

  return [];
};

const Gift = () => {
  const preparecsv = false;
  let { setTopbarHeader, topbarHeader } = useContext(StateContext);
  const giftHeight = "gift";
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    giftID: "--",
    amount: "--",
    sender: "--",
    recipient: "--",
    privacySetting: "--",
    dateSent: "--",
    note: "--",
    giftImages: [],
    recipientTransactionID: "--",
    senderTransactionID: "--",
    senderData: null,
    recipientData: null,
  });

  function formatDate(inputDateStr) {
    let inputDate = new Date(inputDateStr);
    if (isNaN(inputDate.getTime()) || !inputDateStr) {
      const randomDate = new Date(
        Date.now() - Math.floor(Math.random() * 30) * 24 * 60 * 60 * 1000
      );

      inputDate = randomDate;
    }

    const year = inputDate.getFullYear().toString();
    const month = (inputDate.getMonth() + 1).toString().padStart(2, "0");
    const day = inputDate.getDate().toString().padStart(2, "0");
    const hours = (inputDate.getHours() % 12 || 12).toString().padStart(2, "0");
    const minutes = inputDate.getMinutes().toString().padStart(2, "0");
    const ampm = inputDate.getHours() >= 12 ? "PM" : "AM";

    const formattedDate = `${year}/${month}/${day} ${hours}:${minutes} ${ampm} PT`;

    return formattedDate;
  }


  useEffect(() => {
    const fetchGiftData = async () => {
      if (location?.state?.userData) {
        // Use data from navigation state
        const giftData = location.state.userData;
        document.title = `${giftData.recipient}- Cash Wrap`;
        topbarHeader = "Gift";
        setTopbarHeader(`${topbarHeader} / From ${giftData?.sender || ''} to ${giftData?.recipient || ''} on ${giftData?.dateSent?.split(',')[0].trim() || ''}`);
        setFormData({
          giftID: giftData?.giftID || "--",
          amount: giftData?.giftAmount || "--",
          sender: giftData?.sender || "--",
          recipient: giftData?.recipient || "--",
          privacySetting: giftData?.privacySetting || "--",
          dateSent: formatDate(giftData?.createdAt) || "--",
          note: giftData?.giftNote || "--",
          giftImages: normalizeGiftImageUrls(giftData?.giftPhoto, giftData?.giftGIF),
          recipientTransactionID: giftData?.recipientTransactionID || "--",
          senderTransactionID: giftData?.senderTransactionID || "--",
          senderData: giftData?.senderData,
          recipientData: giftData?.recipientData
        });
      } else if (id) {
        // Fetch from API if accessing URL directly
        setLoading(true);
        try {
          const token = localStorage.getItem("authToken");
          const response = await axios.get(
            `${process.env.REACT_APP_BASE_URL}/gifts/${id}`,
            {
              headers: {
                Authorization: token,
              },
            }
          );
          const giftData = response.data.data;
          document.title = `${giftData.giftRecipient?.username || 'Gift'}- Cash Wrap`;
          topbarHeader = "Gift";
          const senderName = giftData.giftSender 
            ? (giftData.giftSender.username || `${giftData.giftSender.firstName} ${giftData.giftSender.lastName}`)
            : "--";
          const recipientName = giftData.giftRecipient
            ? (giftData.giftRecipient.username || `${giftData.giftRecipient.firstName} ${giftData.giftRecipient.lastName}`)
            : "--";
          setTopbarHeader(`${topbarHeader} / From ${senderName} to ${recipientName} on ${formatDate(giftData.createdAt).split(',')[0].trim() || ''}`);
          setFormData({
            giftID: giftData._id || "--",
            amount: giftData.giftAmount || "--",
            sender: senderName,
            recipient: recipientName,
            privacySetting: "Public",
            dateSent: formatDate(giftData.createdAt) || "--",
            note: giftData.giftNote || "--",
            giftImages: normalizeGiftImageUrls(giftData.giftPhoto, giftData.giftGIF),
            recipientTransactionID: giftData.recipientTransactionID || "--",
            senderTransactionID: giftData.senderTransactionID || "--",
            senderData: giftData.giftSender,
            recipientData: giftData.giftRecipient
          });
        } catch (error) {
          console.error("Error fetching gift data:", error);
          toast.error("Failed to load gift details.", { position: toast.POSITION.TOP_CENTER });
        } finally {
          setLoading(false);
        }
      }
    };

    fetchGiftData();
  }, [location.state, id]);


  const onMenuClick = (number) => {
    if (number === "first") {
      navigate(`/app-users/user/${formData?.senderData?._id}`, {
        state: {
          reportedByData: formData?.senderData
        }
      })
    }
    if (number === "second") {
      navigate(`/app-users/user/${formData?.recipientData?._id}`, {
        state: {
          sourceAccountData: formData?.recipientData
        }
      })
    }
  }

  return (
    <div className="home-container">
      <ToastContainer />
      <Navbar />

      <div className="content-container">
        <Sidebar newHeight={giftHeight} />
        <div className="main-content">
          <div className="topbar-container">
          </div>
          <div className="main-content">
            <div className="topbar-container">
              <Topbar preparecsv={preparecsv} />
            </div>
            <Box width='100%'>
              {loading ? (
                <Container className="mt-5">
                  <Typography>Loading gift details...</Typography>
                </Container>
              ) : (
              <Container className="mt-5">
                <Row>
                  <Col md={6} className="mb-3 d-flex justify-content-end">
                    <SimpleCard heading='Gift ID' data={formData.giftID} />
                  </Col>
                  <Col md={6} className="mb-3 d-flex justify-content-start">
                    <SimpleCard heading='Gift Amount' data={formData.amount} />
                  </Col>
                </Row>

                <Row className="justify-content-center">
                  <Col md={6} className="mb-3 d-flex justify-content-end">
                    <SimpleCard heading='Sender' data={formData.sender} icon={true} onMenuClick={() => onMenuClick("first")} />
                  </Col>
                  <Col md={6} className="mb-3 d-flex justify-content-start">
                    <SimpleCard heading='Recipient' data={formData.recipient} icon={true} onMenuClick={() => onMenuClick("second")} />
                  </Col>
                </Row>

                <Row className="justify-content-center">
                  <Col md={6} className="mb-3 d-flex justify-content-end">
                    <SimpleCard heading='Sender Transaction ID' data={formData.senderTransactionID} icon={true} />
                  </Col>
                  <Col md={6} className="mb-3 d-flex justify-content-start">
                    <SimpleCard heading='Recipient Transaction ID' data={formData.recipientTransactionID} icon={true} />
                  </Col>
                </Row>

                <Row className="justify-content-center">
                  <Col md={6} className="mb-3 d-flex justify-content-end">
                    <SimpleCard heading='Note' data={formData.note} />
                  </Col>
                  <Col md={6} className="mb-3 d-flex justify-content-start">
                    <SimpleCard heading='Privacy Setting' data={formData.privacySetting} />
                  </Col>
                </Row>

                <Row className="justify-content-left">
                  <Col md={6} className="mb-3 d-flex justify-content-end" style={{ paddingBottom: "196px" }}>
                    <SimpleCard heading='Date Sent' data={formData.dateSent} />
                  </Col>
                  <Col md={6} className="mb-3 d-flex justify-content-start">
                    {formData.giftImages?.length > 0 ? (
                      <SimpleCard heading='Gift Image' data={
                        <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                          {formData.giftImages.map((imageUrl, index) => (
                            <img
                              key={`${imageUrl}-${index}`}
                              src={imageUrl}
                              alt={`gift ${index + 1}`}
                              style={{ maxWidth: "100%", height: "auto" }}
                            />
                          ))}
                        </Box>
                      } />
                    ) : (
                      <SimpleCard heading='Gift Image' data="--" />
                    )}
                  </Col>
                </Row>
              </Container>
              )}
            </Box>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Gift;
